import React from 'react';
import { useTheme as useAppTheme } from '../../../ThemeContext';
import '../styles/TwoFactorSmsModal.css';

export default function TwoFactorSmsModal({
  open,
  maskedDestination,
  sending = false,
  smsCode,
  onSmsCodeChange,
  onSubmit,
  onClose,
  loading,
  error,
  blocking = false,
  onCancel,
}) {
  const { mode } = useAppTheme();

  if (!open) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(e);
  };

  const handleBackdropClick = blocking ? undefined : onClose;
  const handleCancel = onCancel || onClose;

  return (
    <div
      className="tfSmsModal__backdrop"
      data-theme={mode}
      onClick={handleBackdropClick}
      role="presentation"
    >
      <section
        className="tfSmsModal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="tfSmsModalTitle"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="tfSmsModal__header">
          <h2 id="tfSmsModalTitle" className="tfSmsModal__title">
            Verify SMS code
          </h2>
          {!blocking ? (
            <button type="button" className="tfSmsModal__close" onClick={onClose} aria-label="Close">
              ×
            </button>
          ) : null}
        </header>

        <form id="tfSmsCodeForm" className="tfSmsModal__body" onSubmit={handleSubmit}>
          <p className="tfSmsModal__text">
            {sending
              ? 'Sending your 6-digit code… This usually takes a few seconds.'
              : `Enter the 6-digit code sent${maskedDestination ? ` to ${maskedDestination}` : ''}.`}
          </p>
          {error ? (
            <div className="tfSmsModal__alert" role="alert">
              {error}
            </div>
          ) : null}
          <label className="tfSmsModal__label" htmlFor="tfSmsCode">
            SMS verification code
          </label>
          <input
            id="tfSmsCode"
            className="tfSmsModal__input"
            type="text"
            inputMode="numeric"
            maxLength={6}
            autoComplete="one-time-code"
            placeholder={sending ? 'Waiting for code…' : '6-digit code'}
            value={smsCode}
            onChange={(e) => onSmsCodeChange(String(e.target.value || '').replace(/\D/g, '').slice(0, 6))}
            disabled={sending || loading}
            autoFocus
          />
        </form>

        <footer className="tfSmsModal__footer">
          <button type="button" className="tfSmsModal__btn tfSmsModal__btn--ghost" onClick={handleCancel} disabled={loading}>
            {blocking ? 'Start over' : 'Cancel'}
          </button>
          <button
            type="submit"
            form="tfSmsCodeForm"
            className="tfSmsModal__btn tfSmsModal__btn--primary"
            disabled={sending || loading || smsCode.length !== 6}
          >
            {loading ? 'Verifying…' : sending ? 'Sending code…' : 'Verify code'}
          </button>
        </footer>
      </section>
    </div>
  );
}
